import { render, staticRenderFns } from "./blok-conversion.vue?vue&type=template&id=499ceddd"
import script from "./blok-conversion.vue?vue&type=script&lang=js"
export * from "./blok-conversion.vue?vue&type=script&lang=js"
import style0 from "./blok-conversion.vue?vue&type=style&index=0&id=499ceddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports